import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Page404Component } from './pages/page404/page404.component';
import { blogRoutes } from './pages/blog/blog-routing.module';
import { exchangeRoutes } from './pages/ads/exchange-routing.module';

export const filePath: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
    data: {
      sitemap: {
        loc: '/',
        lastmod: '2026-09-24',
      },
      meta: {
        loc: '/',
        fileName: 'HOME',
        title: 'Crypto FIX API, OMS and EMS — 30+ Exchanges | Axon Trade',
        description:
          'Crypto FIX API, OMS and EMS connecting 30+ exchanges through one FIX 4.4 session, with normalized L2 market data across spot, futures, options and perpetual swaps',
        keywords:
          'crypto oems, crypto fix api, fix api, crypto exchange fix api, crypto trading, algotrading, crypto hft, high frequency trading crypto',
        imgUrl: '/assets/twitter-card/axon-trade-home-page-twitter-card.jpg',
        og_type: 'website',
      },
      structuredData: {
        type: 'home',
      },
    },
  },
  {
    path: 'blog',
    loadComponent: () => import('./pages/blog/blog.component').then((m) => m.BlogComponent),
    data: {
      sitemap: {
        loc: 'blog',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'blog',
        fileName: '/blog',
        title: 'Blog | Axon Trade',
        description: 'New and updates on Axon Trade products and services',
        keywords:
          'fix api,market data,real time market data,fix api crypto,binance fix api,fix api for crypto trading,fix api for digital asset trading,industry,fix protocol,fix protocol for crypto,crypto exchange status,crypto latency arb,crypto latency arbitrage,latency arb trading,low-latency,mt4 crypto,mt5 crypto,metaquotes crypto,mt4 bridge for crypto,kucoin fix api,kucoin trading api,kucoin hft,bitget fix api,bitget trading api,bitget algo trading',
        imgUrl: '/assets/twitter-card/axon-trade-home-page-twitter-card.jpg',
        og_type: 'article',
      },
    },
  },
  {
    path: 'products/fix-api',
    loadComponent: () => import('./pages/products/fix-api/fix-api.component').then((m) => m.FixApiComponent),
    data: {
      sitemap: {
        loc: 'products/fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'products/fix-api',
        fileName: 'products/fix-api',
        title: 'FIX API for digital asset trading | Axon Trade',
        description:
          'FIX API for digital asset trading, real-time normalized market data feeds, low-latency execution services, and a secure environment inside Equinix data centers.',
        keywords: 'fix api,crypto trading,cryptocurrency,digital assets,digital asset trading,crypto exchanges',
        imgUrl: '/assets/twitter-card/axon-trade-fix-api-twitter-card.jpg',
        og_type: 'article',
      },
    },
  },
  {
    path: 'fix-api-overview',
    loadComponent: () =>
      import('./pages/products/fix-api-overview/fix-api-overview.component').then((m) => m.FixApiOverviewComponent),
    data: {
      sitemap: {
        loc: 'fix-api-overview',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'fix-api-overview',
        fileName: '/fix-api-overview',
        title: 'FIX API Overview | Axon Trade',
        description:
          'FIX API is a proven, decades old method of connecting markets. We have created our own that connects all of the major cryptocurrency exchanges. FIX is widely adopted & much faster',
        keywords: 'fix,financial information exchange,digital assets,crypto,cryptocurrency',
        imgUrl: '/assets/twitter-card/axon-trade-fix-api-overview-twitter-card.jpg',
        og_type: 'article',
      },
    },
  },
  {
    path: 'products/real-time-normalized-market-data',
    loadComponent: () =>
      import('./pages/products/market-data/market-data.component').then((m) => m.MarketDataComponent),
    data: {
      sitemap: {
        loc: 'products/real-time-normalized-market-data',
        lastmod: '2025-02-12',
      },
      meta: {
        loc: 'products/real-time-normalized-market-data',
        fileName: '/products/real-time-normalized-market-data',
        title: 'Real-time Normalized Crypto Market Data | Axon Trade',
        description:
          'Axon Trade provides real-time crypto market data through FIX and WebSockets API for all popular exchanges, including Binance, Coinbase, OKX, Kraken, and Huobi',
        keywords:
          'crypto market data,crypto real time market data,crypto market data api,crypto market data provider,binance market data,coinbase market data,kraken market data,okx market data',
        imgUrl: '/assets/twitter-card/axon-trade-market-data-twitter-card.jpg',
        og_type: 'article',
      },
    },
  },
  {
    path: 'supported-exchanges',
    loadComponent: () =>
      import('./pages/supported-exchanges/supported-exchanges.component').then((m) => m.SupportedExchangesComponent),
    data: {
      sitemap: {
        loc: 'supported-exchanges',
        lastmod: '2025-02-12',
      },
      meta: {
        loc: 'supported-exchanges',
        fileName: '/supported-exchanges',
        title: 'Supported Exchanges | Axon Trade',
        description:
          'Axon Trade is connected to 30+ crypto exchanges. We support all markets, available on exchanges - spot, margin, perpetual swaps, futures, and options',
        keywords:
          'crypto,crypto exchanges,crypto trading,binance,huobi,okx,bybit,bitmex,bitfinex,coinbase,hft,high frequency trading,algotrading',
        imgUrl: '/assets/twitter-card/axon-trade-supported-exchanges-page-twitter-card.jpg',
        og_type: 'article',
      },
    },
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./pages/contact-us/contact-us.component').then((m) => m.ContactUsComponent),
    data: {
      sitemap: {
        loc: 'contact-us',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'contact-us',
        fileName: '/contact-us',
        title: 'Axon Trade - OEMS for Digital Asset Trading',
        description:
          'We provide a unique combination of low-latency execution services, real-time market data feeds, and a secure hosted environment inside Equinix data centers.',
        keywords:
          'crypto oems, crypto fix api, fix api, crypto exchange fix api, crypto trading, algotrading, crypto hft, high frequency trading crypto',
        imgUrl: '/assets/twitter-card/axon-trade-home-page-twitter-card.jpg',
        og_type: 'website',
      },
    },
  },
  {
    path: 'access-demo',
    loadComponent: () =>
      import('./pages/access-demo-environment/access-demo-environment.component').then(
        (m) => m.AccessDemoEnvironmentComponent,
      ),
    data: {
      sitemap: {
        loc: 'access-demo',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'access-demo',
        fileName: '/access-demo',
        title: 'Axon Trade - OEMS for Digital Asset Trading',
        description:
          'We provide a unique combination of low-latency execution services, real-time market data feeds, and a secure hosted environment inside Equinix data centers.',
        keywords:
          'crypto oems, crypto fix api, fix api, crypto exchange fix api, crypto trading, algotrading, crypto hft, high frequency trading crypto',
        imgUrl: '/assets/twitter-card/axon-trade-home-page-twitter-card.jpg',
        og_type: 'website',
      },
    },
  },
  {
    path: 'coming-soon',
    loadComponent: () => import('./pages/coming-soon/coming-soon.component').then((m) => m.ComingSoonComponent),
    data: {
      meta: {
        loc: 'coming-soon',
        fileName: '/coming-soon',
        title: 'Coming soon | Axon Trade',
        description:
          'This page is currently under construction and will be live shortly. We’re committed to providing you with meaningful content and updates, and we’re grateful for your ongoing support.',
        imgUrl: '/assets/twitter-card/axon-trade-home-page-twitter-card.jpg',
        canonical: false,
      },
    },
  },
  {
    path: 'booking-confirmation',
    loadComponent: () =>
      import('./pages/booking-confirmation/booking-confirmation.component').then((m) => m.BookingConfirmationComponent),
    data: {
      meta: {
        loc: 'booking-confirmation',
        fileName: '/booking-confirmation',
        title: 'Booking confirmation | Axon Trade',
        description: 'You have successfully booked a call on Calendly',
        imgUrl: '/assets/twitter-card/axon-trade-home-page-twitter-card.jpg',
        canonical: false,
      },
    },
  },
  {
    path: '404.html',
    loadComponent: () => import('./pages/page404/page404.component').then((m) => m.Page404Component),
    data: {
      meta: {
        loc: '404.html',
        fileName: '/404.html',
        title: '404 | Axon Trade',
        description:
          'We’re sorry, but the page you’re looking for could not be found. It may have been moved, deleted, or never existed in the first place.',
        imgUrl: '/assets/twitter-card/axon-trade-home-page-twitter-card.jpg',
        canonical: false,
      },
    },
  },
  ...blogRoutes,
  ...exchangeRoutes,
  {
    path: '**',
    component: Page404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(filePath)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
